<template>
  <!-- START MAIN CARD -->
  <div
    class="bg-white rounded-lg shadow hover:shadow-lg hover:cursor-pointer mb-6 "
  >
    <router-link
      :to="{ name: 'survey-builder', params: { surveyid: survey.id } }"
      class="w-full cursor-pointer no-underline hover:no-underline"
    >
    <div class="h-36 flex flex-row justify-center items-center">
      <p class="px-4 pt-4 pb-6 text-gray-600 text-base font-bold my-auto">
        {{ name }}
      </p>
    </div>

    </router-link>

    <hr />

    <div class="flex flex-row justify-between p-4">
      <router-link
        class="text-xs hover:no-underline hover:text-gray-600 cursor-pointer font-semibold inline-block py-1 px-2 uppercase rounded text-gray-600 bg-purple-200 uppercase last:mr-0 mr-1"
        v-text="responseCount + ' responses'"
        :to="{ path: '/results/' + survey.id }"
      >
      </router-link>

      <BaseDropDown
        v-on:clone-survey="$emit('clone-survey', survey.id)"
        v-on:confirm-delete="$emit('confirm-delete', survey.id)"
        v-bind:items="[
          {
            label: 'Edit survey',
            route: { path: '/builder/' + survey.id },
            icon: 'heroicons/outline/pencil-alt',
          },
          {
            label: 'Clone survey',
            event: 'clone-survey',
            args: survey.id,
            icon: 'heroicons/outline/duplicate',
          },
          {
            label: 'Delete survey',
            event: 'confirm-delete',
            args: survey.id,
            icon: 'heroicons/outline/x-circle',
          },
          {
            label: 'Survey results',
            route: { path: '/results/' + survey.id },
            icon: 'heroicons/outline/chart-square-bar',
          },
          {
            label: 'Install Code',
            route: { path: '/settings/' + survey.id },
            icon: 'heroicons/outline/cog',
          },
        ]"
      >
        <template v-slot:button>
          <div class="items-center flex">
            <span
              class="mr-4 text-gray-400 hover:text-gray-500 hover:bg-gray-200 inline-flex items-center justify-center rounded"
            >
              <svg-icon
                icon="heroicons/outline/dots-horizontal"
                class="h-6 w-6 text-gray-600"
              ></svg-icon>
            </span>
          </div>
        </template>
      </BaseDropDown>
    </div>
  </div>
</template>

<script>
import Survey from "@/models/Survey";
import axios from "axios";
//import SvgImage from "@/components/SvgImage";

export default {
  data() {
    return {
      responseCount: 0,
    };
  },
  props: ["survey"],
  //components: { SvgImage },
  computed: {
    name() {
      return this.survey.name;
    },
    //Get the first image used in the survey
    previewImage() {
      return 'undraw/undraw_Post_re_mtr4';
      //return this.survey.steps[0].options[0].image;
    },
  },
  methods: {
    async init() {
      var resp = await axios.get(`api/response/count/${this.survey.id}`);
      this.responseCount = resp.data;
      console.log("response: " + resp.data);
    },
  },
  created() {
    this.init();
  },
};
</script>

<style></style>
